<template>
  <FormLoading :loading="loading" :count="8">
    <template>
      <div class="height-percent-100">
        <div v-if="hasHeader" class="parvandeh-notification__header">
          <div class="parvandeh-notification__right-box">
            <span
              v-if="mode === 'MOBILE'"
              class="parvandeh-notification__header-close"
              @click="closeMobilePopup"
            >
              <mdicon name="close" size="24" />
            </span>
            <span v-if="expanded" class="parvandeh-notification__header-text">
              {{ $lang.incompleteParvandehInformation }}
            </span>
            <slide-y-down-transition>
              <span
                v-if="
                  !expanded && totalIncompleteItemCount && mode === 'DESKTOP'
                "
                class="chips chips--error chips--pill pb-0"
              >
                {{ totalIncompleteItemCount }}
              </span>
            </slide-y-down-transition>
          </div>
        </div>
        <div class="parvandeh-notification__error">
          {{
            $lang.incompleteParvandehInformationCount.replace(
              "{0}",
              totalIncompleteItemCount
            )
          }}
        </div>
        <div class="margin-top-10 margin-bottom-22 padding-x-8">
          <ProgressBar variant="primary" direction="right" :width="percent" />
        </div>
        <div :class="`parvandeh-notification__body ${bodyClass}`">
          <div class="parvandeh-notification__items">
            <div
              class="parvandeh-notification__item"
              v-for="(item, index) in items"
              :key="`${index}-a`"
            >
              <div
                class="parvandeh-notification__item-header"
                v-b-toggle="`item-${index}`"
              >
                <div class="parvandeh-notification__right-box">
                  <span
                    class="parvandeh-notification__item-icon"
                    :class="{ 'color-success': item.done }"
                  >
                    <mdicon
                      v-if="item.done"
                      name="check-circle-outline"
                      size="24"
                    />
                    <mdicon v-else :name="item.icon" size="24" />
                  </span>
                  <span
                    class="parvandeh-notification__item-text"
                    :class="`color-complementary-${item.done ? '200' : '400'}`"
                  >
                    {{ item.caption }}
                  </span>
                </div>
                <div v-if="!item.done" class="parvandeh-notification__left-box">
                  <span class="parvandeh-notification__item-time">
                    {{ item.time }} {{ $lang.minute }}
                  </span>
                  <span class="parvandeh-notification__item-collapse">
                    <mdicon name="chevron-down" size="24" />
                  </span>
                </div>
              </div>
              <b-collapse accordion="item-accordion" :id="`item-${index}`">
                <div
                  v-if="!item.done"
                  class="parvandeh-notification__item-body"
                >
                  <div
                    class="parvandeh-notification__sub-item"
                    v-for="(subItem, index) in item.subItems"
                    :key="`${index}-b`"
                    @click="goToLink(item)"
                  >
                    <span class="parvandeh-notification__sub-item-icon">
                      <mdicon name="file-outline" size="16" />
                    </span>
                    <span class="parvandeh-notification__sub-item-text">
                      {{ subItem }}
                    </span>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </template>
  </FormLoading>
</template>

<script>
import ProgressBar from "@/components/re-design/progress-bar/ProgressBar.vue";
import { FormLoading } from "@/components/re-design/forms";
import { pathOr, isEmpty } from "ramda";
import { goToRoute, toastAlert } from "@/shared/utils";
import { toRefs } from "vue";

export default {
  components: { ProgressBar, FormLoading },
  props: {
    mode: {
      type: String,
      default: "DESKTOP",
    },
    target: {
      type: String,
      default: "profile", // value is should profile or person
    },
    totalIncompleteItemCount: {
      type: Number,
      default: 0,
    },
    percent: {
      type: Number,
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
    hasHeader: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: "",
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    parvandehCode: {
      type: [String, Number],
      default: null,
    },
  },
  setup(props, { emit }) {
    // bind props
    const { target, parvandehCode } = toRefs(props);

    const closeMobilePopup = () => emit("closeMobilePopup", false);

    const goToLink = (item) => {
      const personCode = pathOr(null, ["link", "person_code"], item);
      const routeName = pathOr(null, ["link", "route_name"], item);
      if (!personCode || !routeName) {
        const message = generateLang("notAccessLink");
        return toastAlert(message, "warning");
      }

      let params = { code: personCode };
      if (target.value === "person") {
        params = { code: personCode, parvandehCode: parvandehCode.value };
      }

      if (isEmpty(item.hasData) || item.hasData) {
        return goToRoute(`${target.value}-${routeName}`, params, {}, false);
      } else {
        return goToRoute(target.value, params, {}, false);
      }
    };

    // return data to be used in template
    return { closeMobilePopup, goToLink };
  },
};
</script>
